export default {
  user: {},
  token: '',
  permissions: [],
};
